var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotsHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83268 13.9987H5.84435M13.9993 13.9987H14.011M22.166 13.9987H22.1777M6.99935 13.9987C6.99935 14.643 6.47701 15.1654 5.83268 15.1654C5.18835 15.1654 4.66602 14.643 4.66602 13.9987C4.66602 13.3544 5.18835 12.832 5.83268 12.832C6.47701 12.832 6.99935 13.3544 6.99935 13.9987ZM15.166 13.9987C15.166 14.643 14.6437 15.1654 13.9993 15.1654C13.355 15.1654 12.8327 14.643 12.8327 13.9987C12.8327 13.3544 13.355 12.832 13.9993 12.832C14.6437 12.832 15.166 13.3544 15.166 13.9987ZM23.3327 13.9987C23.3327 14.643 22.8103 15.1654 22.166 15.1654C21.5217 15.1654 20.9993 14.643 20.9993 13.9987C20.9993 13.3544 21.5217 12.832 22.166 12.832C22.8103 12.832 23.3327 13.3544 23.3327 13.9987Z",
    stroke: "#424242",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsHorizontal);
export default __webpack_public_path__ + "static/media/dots-horizontal.04b2a97329f66a4d14cb5f29a97379b2.svg";
export { ForwardRef as ReactComponent };